import { giphyDarkCharcoal } from '@giphy/js-brand'
import React, { SyntheticEvent, useState } from 'react'
import styled from 'styled-components'
import { UploadFieldBlock } from './blocks'
import { UtilityButton } from './buttons'

const Input = styled(UploadFieldBlock)`
    display: flex;
    height: 36px;
    width: 100%;

    input[type='text'] {
        width: 100%;
    }
`

const Button = styled(UtilityButton)`
    background: ${giphyDarkCharcoal};
    color: #fff;
    flex-shrink: 0;
    margin-left: 10px;
`

const DeleteButton = styled(Button)`
    padding: 0;
    width: 36px;
`

const AddButton = styled(Button)`
    width: 120px;

    i:first-child {
        margin-right: 12px;
    }
`

type Props = {
    className?: string
    defaultValue?: string
    onAdd?: () => void
    onRemove?: () => void
    onFocus?: () => void
    onInput?: (value: string) => void
}

const CreationToolsCaptionInput = ({ className, defaultValue = '', onAdd, onRemove, onFocus, onInput }: Props) => {
    const [value, setValue] = useState<string>(defaultValue)

    const onChange = (e: SyntheticEvent<HTMLInputElement, Event>) => {
        setValue(e.currentTarget.value)
        onInput && onInput(e.currentTarget.value)
    }

    return (
        <Input className={className}>
            <input
                {...{
                    type: 'text',
                    placeholder: 'Type your caption...',
                    value,
                    onChange,
                    onFocus,
                }}
            />
            {onRemove && (
                <DeleteButton onClick={onRemove}>
                    <i className="ss-trash" />
                </DeleteButton>
            )}
            {onAdd && (
                <AddButton disabled={!value} onClick={onAdd}>
                    <i className="ss-plus" />
                    Add
                </AddButton>
            )}
        </Input>
    )
}

export default CreationToolsCaptionInput
